var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEyeSlash = function SvgEyeSlash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    fill: "none",
    viewBox: "0 0 19 19"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M7.536 4.604c3.152-.949 6.61.417 8.882 4.098.195.316.292.474.348.719.04.181.04.477 0 .658-.055.245-.153.403-.348.718a11.43 11.43 0 0 1-1.14 1.55M7.625 8.191a2.438 2.438 0 0 0 3.455 3.414"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M5.167 5.813c-.955.71-1.835 1.674-2.585 2.89-.195.315-.292.473-.347.718-.04.181-.04.477 0 .658.055.245.153.403.348.72 2.74 4.441 7.21 5.512 10.785 3.21M2.563 2.813l13.874 13.874"
  })));
};
export default SvgEyeSlash;